import UniqueConsumerPopUp from "./uniqueConsumerPopup.container";

export default UniqueConsumerPopUp;
